import { Template, TemplateProps } from "./types";
import { getComputedColors, extractStyleValues } from "./utils";

export const gridTemplate: Template = {
  id: "grid",
  name: "Grid Layout",
  icon: "fa-solid fa-grid",
  description: "3-column grid that adapts to 2 columns on tablet and 1 on mobile",

  generateLayoutCSS(componentId: string): string {
    const selector = `#${componentId}[data-template="grid"]`;
    
    return `
      /* Grid Layout - Desktop (3 columns) */
      ${selector} #job-items-wrapper:has(.job-item) {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
      }

      /* Grid Layout - Tablet (2 columns) */
      @media (max-width: 992px) {
        ${selector} #job-items-wrapper:has(.job-item) {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
      }

      /* Grid Layout - Mobile (1 column) */
      @media (max-width: 576px) {
        ${selector} #job-items-wrapper:has(.job-item) {
          grid-template-columns: repeat(1, minmax(0, 1fr));
        }
      }
    `;
  },

  generateStylingCSS(componentId: string, props: TemplateProps): string {
    const selector = `#${componentId}[data-template="grid"]`;
    const styles = extractStyleValues(props);
    const buttonColors = getComputedColors(styles.buttonBackgroundColor);
    const captionColors = getComputedColors(styles.captionBackgroundColor);

    return `
      ${selector} .job-item {
        background-color: ${styles.cardBackgroundColor};
        border-radius: ${styles.cardBorderRadius}!important;
      }

      ${selector} .job-item-caption {
        background-color: ${captionColors.bgColor};
        color: ${captionColors.labelColor};
        border-radius: ${styles.captionBorderRadius};
      }

      ${selector} .job-item-heading {
        color: ${styles.headingColor};
      }

      ${selector} .job-item-link {
        background-color: ${buttonColors.bgColor};
        border-color: ${buttonColors.bgColor};
        color: ${buttonColors.labelColor};
        border-radius: ${styles.buttonBorderRadius};
      }

      ${selector} .job-item-link:hover {
        background-color: ${buttonColors.bgHoverColor};
      }
    `;
  },
};

